var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("page", { staticClass: "data-overview-page" }, [
    _c("div", { staticClass: "toolbar" }, [
      _c(
        "div",
        { staticClass: "toolbar-left" },
        [
          _c(_setup.DateTimeRangePicker, {
            staticStyle: { width: "300px" },
            attrs: {
              "picker-type": "daterange",
              size: "mini",
              clearable: false,
            },
            model: {
              value: _setup.dateRange,
              callback: function ($$v) {
                _setup.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
          _c(
            "div",
            { staticClass: "quick" },
            _vm._l(_setup.quickRangeOptions, function (item) {
              return _c(
                "el-button",
                {
                  key: item.key,
                  attrs: {
                    size: "mini",
                    type:
                      _setup.currentDateRangeKey === item.key
                        ? "primary"
                        : "default",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.applyQuickRange(item.key)
                    },
                  },
                },
                [_vm._v(_vm._s(item.label))]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _setup.loading,
            expression: "loading",
          },
        ],
        staticClass: "cards",
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 16 } },
          _vm._l(_setup.cards, function (card) {
            return _c(
              "el-col",
              { key: card.key, attrs: { span: 6 } },
              [
                _c(
                  "el-card",
                  { staticClass: "stat-card", attrs: { shadow: "never" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stat-card-inner",
                        class: { "is-compact": !(card.sub && card.sub.length) },
                      },
                      [
                        _c("div", { staticClass: "stat-title" }, [
                          _vm._v(_vm._s(card.title)),
                        ]),
                        card.showValue !== false
                          ? _c(
                              "div",
                              {
                                staticClass: "stat-value",
                                class: {
                                  "is-large": !(card.sub && card.sub.length),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _setup.formatValue(
                                        card.value,
                                        card.format
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        card.sub && card.sub.length
                          ? _c(
                              "div",
                              { staticClass: "stat-sub" },
                              _vm._l(card.sub, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.label,
                                    staticClass: "stat-sub-row",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "stat-sub-label" },
                                      [_vm._v(_vm._s(item.label))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "stat-sub-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _setup.formatValue(
                                              item.value,
                                              item.format
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }